import { accessRole } from "../../../../helpers/access_role"
import apiResponse from '../../../../services/apiResponse'
import React, { Component, Fragment, createRef, useState, useRef } from "react"
import {
    Label,
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Modal, 
    ModalBody, 
    ModalFooter, 
    ModalHeader,
    Badge
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { cancelToken } from '../../../../services/adapters/base'
import Select from '../../../../helpers/ui/CustomSelect'

import { Link } from "react-router-dom"
import { AvForm, AvField } from "availity-reactstrap-validation"

import TableActiveComponent from './Components/TableActiveComponent'
import PeriodListComponent from './Components/PeriodListComponent'

import IndexBloc from './Blocs/IndexBloc'
class IndexView extends Component {

    indexBloc = new IndexBloc()
    source
    timer
   
    constructor(props) {
        super(props)
        this.state = {
            activeTab: "1",
            modal: false,
            list: [],
            eselon: [],
            draft: 0,
            currentPeriod: null,
            showPeriodList: false,
            filter: 
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: 20,
                    sort_order: {
                        column: 'work_unit_sort',
                        order: 'asc' 
                    }
                }
        }
        this.activeRef = createRef()
    }

    reloadActiveRef = () => this.activeRef.current.setTokenAPI()

    toggleModal = () => this.setState({ modal: !this.state.modal })

    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({ activeTab: tab })
        }
    }

    submitData = async () => {
        await this.indexBloc.fetchCreate(this.state.dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false,
                    modal: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false,
                    modal: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true,
                    modal: false
                }
                break;
             case 'failed':
                forState = {
                    failed: false,
                    modal: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    loadDraft = async () => {
        await this.indexBloc.fetchCountDraft({})
    }
    
    loadList = async () => {
        const { filter } = this.state
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        const query = {
            search: filter.filter_value,
            limit: filter.page_size,
            offset: offset,
            order: filter.sort_order.column,
            sort: filter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadList()
        this.loadDraft()
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                ...values
            },
            confirm: true
        })
    }

    loadEselon = async (parent) => {
        await this.indexBloc.fetchEselon({ uuid: parent.work_unit_uuid })
    }

    handleSelectInputChange = value => {
        clearTimeout(this.timer)
            
        this.state.filter.filter_value = value
            
        this.timer = setTimeout(() => this.loadList(), 800)
    }

    handlePeriodList = (response) => {
        this.setState({
            loadingCurrent: true
        }, () => {
            this.setState({
                showPeriodList: false,
                currentPeriod: response,
                loadingCurrent: false
            })
        });
    }

    componentDidMount() {
        this.setTokenAPI()
        this.indexBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ list: result.data.response.result })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.eselonChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.LOADING:
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        eselon: result.data.response
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        
                    });
                    break
                default:
                    break
            }
        })

        this.indexBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    this.loadDraft()
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.indexBloc.countDraftChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.LOADING:
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        draft: result.data.response
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        
                    });
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.indexBloc.rowtableChannel?.unsubscribe()
        this.indexBloc.eselonChannel?.unsubscribe()
        this.indexBloc.createChannel?.unsubscribe()
        this.indexBloc.countDraftChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                {
                                    (accessRole('create')) &&
                                        <div className="waves-effect" style={{ marginRight: 5 }}>
                                            <Button color="primary" onClick={() => this.toggleModal()}>Tambah Satuan Baru</Button>
                                        </div>
                                }
                            </div>
                            <CardTitle>Struktur Organisasi</CardTitle>
                            <CardSubtitle>List Struktur Organisasi</CardSubtitle>
                            <hr/>
                            <Row>
                                <Col md={12}>
                                    <div className="d-flex flex-row bd-highlight">
                                        <div className="pe-2 pb-2 bd-highlight" style={{paddingTop: 7}}>
                                            <span>
                                                <Button color="success" style={{ marginRight: 5 }} onClick={() => this.setState({ showPeriodList: true })}><i className="uil-align-left"></i> Lihat Histori</Button>
                                                { accessRole('approve') &&
                                                    <Link to="/master/struktur-organisasi.html?draft" style={{ marginRight: 5 }}>
                                                        <Button color="secondary"><i className="uil-align-left"></i> Draft <Badge color="primary">{this.state.draft ? this.state.draft : 0}</Badge></Button>
                                                    </Link>
                                                }
                                                {
                                                    (accessRole('read')) &&
                                                        <Link to="/master/struktur-organisasi.html?charts" style={{ marginRight: 5 }}>
                                                            <Button color="primary">Chart Organisasi</Button>
                                                        </Link>
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <hr/>
                            <TableActiveComponent ref={this.activeRef} handleInactiveSuccess={() => this.reloadActiveRef()} loadDraft={() => this.loadDraft()} currentPeriod={this.state.currentPeriod} />
                        </CardBody>
                    </Card>
                </Container>

                <Modal
                    size="lg"
                    isOpen={this.state.modal}
                    toggle={() => this.toggleModal()}
                >
                    <ModalHeader 
                        toggle={() => this.toggleModal()}
                    >
                        Tambah Satuan/Unit Baru
                    </ModalHeader>
                    <AvForm
                        className="needs-validation"
                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                    >
                        <ModalBody>
                            <Row className="mb-3">
                                <Label
                                    className="col-md-4 col-form-label"
                                >
                                    Nama Satuan/Unit <span className="text-danger">*</span>
                                </Label>
                                <Col md="8">
                                    <AvField
                                        name="work_unit_name"
                                        placeholder="Nama Struktur Organisasi"
                                        errorMessage="Masukkan Struktur Organisasi"
                                        type="text"
                                        className="form-control"
                                        validate={{ required: { value: true } }}
                                    />
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Label
                                    className="col-md-4 col-form-label"
                                >
                                    Parent
                                </Label>
                                <Col md="8">
                                    <Select 
                                        name="work_unit_parent_uuid"
                                        errorMessage="Pilih Parent Struktur Organisasi"
                                        options={this.state.list} 
                                        optionLabel="work_unit_full_name"
                                        optionValue="work_unit_uuid"
                                        isClearable
                                        placeholder="Pilih Parent (Kosongkan jika ingin dijadikan parent)"
                                        onInputChange={this.handleSelectInputChange}
                                        onChange={opt => this.loadEselon(opt)}
                                    />
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Label
                                    className="col-md-4 col-form-label"
                                >
                                    Eselon <span className="text-danger">*</span>
                                </Label>
                                <Col md="8">
                                    <Select 
                                        name="work_unit_echelon_uuid"
                                        errorMessage="Pilih Eselon"
                                        options={this.state.eselon} 
                                        optionLabel="echelon_name"
                                        optionValue="echelon_uuid"
                                        placeholder="Pilih Eselon"
                                        validate={{ required: { value: true } }}
                                    />
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Label
                                    className="col-md-4 col-form-label"
                                >
                                    Batas Usia Pensiun <span className="text-danger">*</span>
                                </Label>
                                <Col md="8">
                                    <AvField
                                        name="work_unit_bup"
                                        placeholder="Batas Usia Pensiun"
                                        errorMessage="Masukkan Batas Usia Pensiun"
                                        type="text"
                                        className="form-control"
                                        validate={{ required: { value: true } }}
                                    />
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Label
                                    className="col-md-4 col-form-label"
                                >
                                    Grade <span className="text-danger">*</span>
                                </Label>
                                <Col md="8">
                                    <AvField
                                        name="work_unit_job_grade"
                                        placeholder="grade"
                                        errorMessage="Masukkan Grade"
                                        type="text"
                                        className="form-control"
                                        validate={{ required: { value: true } }}
                                    />
                                </Col>
                            </Row>

                            {/* <Row className="mb-3">
                                <Label
                                    className="col-md-4 col-form-label"
                                >
                                    Urutan Struktur Organisasi
                                </Label>
                                <Col md="4">
                                    <AvField
                                        name="work_unit_sort"
                                        placeholder="Urutan Struktur Organisasi"
                                        errorMessage="Masukkan Urutan Struktur Organisasi"
                                        type="number"
                                        className="form-control"
                                    />
                                </Col>
                            </Row> */}

                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="primary"
                                type="submit"
                            >
                                Submit
                            </Button>
                            {' '}
                            <Button 
                                onClick={() => this.toggleModal()}
                            >
                                Cancel
                            </Button>
                        </ModalFooter>
                    </AvForm>
                </Modal>

                <Modal
                    size="lg"
                    isOpen={this.state.showPeriodList}
                    toggle={() => this.setState({ showPeriodList: !this.state.showPeriodList })}
                >
                    <ModalHeader>
                        Daftar Periode Struktur Organisasi
                    </ModalHeader>
                    <ModalBody>
                        <PeriodListComponent changeUUID={this.handlePeriodList} />
                    </ModalBody>
                </Modal>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />

            </Fragment>
        )
    }
}
export default IndexView
